/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { PluginOrPluginGroupParsed } from '../../components/PluginSelection/types';

/**
 * Disabled and filtered out plugins are not available for selection.
 */
export function isPluginOrGroupAvailable( pluginOrGroup: PluginOrPluginGroupParsed ): boolean {
	if ( pluginOrGroup.isDisabled ) {
		return false;
	}

	if ( pluginOrGroup.isFiltered ) {
		return false;
	}

	return true;
}
